<template>
  <div>
    <h3>{{survey.name}}</h3>
    <b-form v-on:submit.prevent="submit()" validated novalidateenc type="multipart/form-data">
      <b-form-group label-for="Name" label="Question">
        <b-form-input type="text" class="form-control-warning" id="Name" v-model="question.name" required></b-form-input>
        <b-form-valid-feedback>
        Valid question provided.
        </b-form-valid-feedback>
        <b-form-invalid-feedback>
        Enter question.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-for="QuestionType" label="Type">
        <b-form-select id="Type"
        :options="typeList"
        required
        v-model="question.type">
        </b-form-select>             
        <b-form-valid-feedback>
        Valid type provided.
        </b-form-valid-feedback>
        <b-form-invalid-feedback>
        Select type.
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="mt-4 text-right">
        <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
        <router-link class="btn btn-success btn-sm" :to="{ path: '/surveys/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
      </div>
    </b-form>
  </div>
</template>
<script>
export default {
  name: 'question',
  props: ['survey','question'],
  computed: {
    typeList: function () {
      let types = [];
      types.push({text: 'Multiple Choice', value: 'multiple-choice'});
      types.push({text: 'Single Choice', value: 'single-choice'});
      types.push({text: 'Text', value: 'text'});
      return types;
    },
    hasOptions () {
      if(this.question.type === 'text') {
        return false;
      }
      return true;
    },
    questionIsEdit () {
      return this.$store.getters.questionIsEdit;
    }
  },
  methods: {
    submit () {      
      let scope = this;      
      if(!scope.question.name) {
            console.log('invalid')
        return
      }
      if(!scope.question.type) {
        console.log('invalid')
        return
      }

      this.$store.commit('updateOption', {});
      this.$store.commit('updateOptionIsEdit', false);

      if(this.questionIsEdit) {
        scope.$store.dispatch('updateQuestion', scope.question).then(result => {
          if(scope.hasOptions) {
            this.$store.commit('updateSurveyMode', 'step-option');
          } else {
            this.$store.commit('updateSurveyMode', 'step-survey');
          }
          this.$store.dispatch('getSurvey', scope.survey._id);
        }, error => {
          console.log(error);
        });
      } else {
        scope.question.survey = scope.survey._id;
        scope.question.user = scope.$store.getters.currentUser.id;
        scope.$store.dispatch('addQuestion', scope.question).then(result => {
          if(scope.hasOptions) {
            this.$store.commit('updateSurveyMode', 'step-option');
          } else {
            this.$store.commit('updateSurveyMode', 'step-survey');
          }
          this.$store.dispatch('getSurvey', scope.survey._id);
        }, error => {
          console.log(error);
        });
      }
    }    
  },
  created () {
    
  }
}
</script>
